<template>
  <b-row>
    <b-col cols="12">
      <dsp-partners-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import DspPartnersTable from './DspPartnersTable.vue'

export default {
  components: {
    BRow,
    BCol,
    DspPartnersTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
